export default {"src":"/_next/static/media/techcity.bb035630.svg","height":23,"width":96,"blurWidth":0,"blurHeight":0};